import * as breakpoints from "../breakpoints";
import { StyleSheet } from "aphrodite";

export default StyleSheet.create({
	mobileOnly: {
		[breakpoints.tabletAndUp]: {
			display: "none",
		},
	},
	tabletAndUp: {
		[breakpoints.mobileOnly]: {
			display: "none",
		},
	},
	desktopOnly: {
		[breakpoints.tabletAndDown]: {
			display: "none",
		},
	},
});



// WEBPACK FOOTER //
// ./src/styles/globalStyles.js